import { usePathname, useSearchParams } from "next/navigation";
import { useGenieContext } from "./use-genie-context";

export interface GenieEntity {
  type:
    | "workflow"
    | "agent"
    | "knowledge_base"
    | "case"
    | "deployment"
    | "template"
    | "table"
    | "workspace";
  id: string;
  name?: string;
}

export function useGeniePage(description: string, entity?: GenieEntity) {
  const pathname = usePathname();
  // The query names the tab, section or version open on the page.
  const query = useSearchParams()?.toString();
  useGenieContext("current_page", "The page the user is currently viewing", {
    path: query ? `${pathname}?${query}` : pathname,
    description,
    entity,
  });
}
